import { request } from './request'
import { userApi } from './user'
import { homeApi } from './home'
import { goodsApi } from './goods'

export { request, userApi, homeApi, goodsApi }

export default {
  request,
  user: userApi,
  home: homeApi,
  goods: goodsApi
}
